import { memo, useEffect, useState } from 'react';
import type { CustomerBalanceResponse } from '@six-pockets/shared';
import { billsApi } from '@/api';
import { formatINR } from '@/utils/format';
import styles from '@/styles/components/CustomerBalanceNote/style.scss';

/**
 * Under the bill's customer in step 2: what they still owe on their older bills, so staff can mention it. Shows
 * nothing while loading, when nothing is due, or if the request fails (it is only a hint).
 * Memoised on the customer id: typing in the totals or payment doesn't re-render it.
 */
export const CustomerBalanceNote = memo(function CustomerBalanceNote({ customerId }: { customerId: string }) {
  const [balance, setBalance] = useState<CustomerBalanceResponse | null>(null);

  useEffect(() => {
    const ctrl = new AbortController();
    setBalance(null);
    billsApi.customerBalance(customerId, ctrl.signal).then(setBalance, () => {});
    return () => ctrl.abort();
  }, [customerId]);

  if (!balance || balance.totalDue <= 0) return null;
  return (
    <p className={styles.note} role="status">
      <span className={styles.label}>Balance due</span>
      <span className={styles.amount}>{formatINR(balance.totalDue)}</span>
    </p>
  );
});
